import { createModel } from 'hox';
import { useState, useEffect } from 'react';
import { ISaleReturnDetail, IISaleReturnDetailList } from '../bmsBillBusSo/bmsBillBusSoType';
import { busBusinesstService } from '../bmsBillBusSo/bmsBillBusSoService';
import moment from 'moment';
import { useBmsSaleRoDetailModel } from '../bmsBillSaleRo/bmsBillSaleRoModel';

export type ISaleDesc = {
	numAll: number;
	itemNumAll: number;
	totalAll: number;
	discountAll: number;
	receivableAll: number;
	[key: string]: any;
};
export const useBmsBusSaleRoDetailModel = createModel(function () {
	const initDesc: ISaleDesc = {
		numAll: 0, //数量
		itemNumAll: 0, //项数
		totalAll: 0, //总计
		discountAll: 0, //折扣,
		receivableAll: 0, //应收
	};
	const { getBmsTreeNodeName } = useBmsSaleRoDetailModel();
	//查看数据
	//查看详情form
	const [detailLookForm, setDetailLookForm] = useState<ISaleReturnDetail>({});
	//查看维修用料详情列表
	const [detailMaterialLookList, setDetailMaterialLookList] = useState<IISaleReturnDetailList[]>(
		[]
	);
	const [lookDesc, setLookDesc] = useState<ISaleDesc>(initDesc);
	useEffect(() => {
		let newDesc: ISaleDesc = initDesc;
		detailMaterialLookList &&
			detailMaterialLookList.forEach((item, index) => {
				let { num, amount } = item;
				newDesc.numAll += Number(num);
				newDesc.totalAll += Number(amount);
			});
		newDesc.itemNumAll = detailMaterialLookList && detailMaterialLookList.length;
		setLookDesc(newDesc);
	}, [detailLookForm, detailMaterialLookList]);
	const getDetailEditOne = async (id: string, pattern?: string) => {
		let { retData } = await busBusinesstService.sreturnOne(id);
		if (retData) {
			const { details, deliveryTime, enterTime, ...from } = retData;
			const newMaterialDetails = details?.map((item) => {
				return {
					...item,
					detailsId: item.id,
				};
			});
			const newFrom = {
				...from,
				enterTime: enterTime ? moment(enterTime) : null,
				deliveryTime: deliveryTime ? moment(deliveryTime) : null,
				customerTypeName: getBmsTreeNodeName(from.customerTypeCode as string),
				productTypeName: getBmsTreeNodeName(from.productTypeCode as string),
				settlementPartyName: getBmsTreeNodeName(from.settlementPartyCode as string),
				payType: getBmsTreeNodeName(from.payType as string),
				invoiceTypeName: getBmsTreeNodeName(from.invoiceTypeCode as string),
				serviceTypeName: getBmsTreeNodeName(from.serviceTypeCode as string),
			};
			setDetailLookForm(newFrom);
			setDetailMaterialLookList((newMaterialDetails as IISaleReturnDetailList[]) ?? []);
		}
	};

	//关闭页签清不同状态缓存
	const resetLookCatch = async (type?: string) => {
		setDetailLookForm({});
		setDetailMaterialLookList([]);
	};

	return {
		detailLookForm,
		detailMaterialLookList,
		lookDesc,
		setDetailLookForm,
		setDetailMaterialLookList,
		setLookDesc,
		getDetailEditOne,
		resetLookCatch,
	};
});
